"use strict";
import { TransactionStepType } from "features/transactions/steps/types";
export function createWrapTransactionStep(txRequest, inputAmount) {
  return txRequest && inputAmount ? { txRequest, type: TransactionStepType.WrapTransaction, amount: inputAmount } : void 0;
}
